export const FIRESTORE_SESSIONS_COLLECTION = "sessions";